export function capitalizeFirstLetter(string: String) {
    return string?.charAt(0)?.toUpperCase() + string?.slice(1);
}